export class SearchModel {
    FilterList: string;
    ItemName: string;
    UserId: number;
    Currency: string;
    PageNum: number;
    MaxRowsPage: number;
    Family: string;
    CustAccount: string;
    ProductionItems: boolean;
    Idioma: string;

    constructor() {
        this.FilterList = '';
        this.ItemName = '';
        this.UserId = 0;
        this.PageNum = 0;
        this.MaxRowsPage = 0;
        this.Family = '';
        this.CustAccount = '';
        this.ProductionItems = false;
        this.Idioma = '';
    }
  }
